export default __webpack_public_path__ + "static/media/ic-sm-sowing-1.8f0e262d.svg";